import { render, staticRenderFns } from "./DogRegistrationFeeTable.vue?vue&type=template&id=730a43a8"
import script from "./DogRegistrationFeeTable.vue?vue&type=script&lang=ts"
export * from "./DogRegistrationFeeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports